// src/components/ContactForm.jsx
import React from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";

const ContactForm = () => {
  const initialValues = {
    name: "",
    email: "",
    phone: "",
    message: "",
  };

  const validationSchema = Yup.object({
    name: Yup.string().required("Name is required"),
    email: Yup.string().email("Invalid email address").required("Email is required"),
    phone: Yup.string().required("Phone number is required"),
    message: Yup.string().required("Message is required"),
  });

  const handleSubmit = (values, { resetForm }) => {
    console.log("Form data:", values);
    resetForm();
  };

  return (
    <div className="max-w-lg mx-auto p-4 bg-white shadow-md rounded-md">
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        <Form>
          {/* Name */}
          <div className="mb-4">
            <label className="block mb-1 font-medium" htmlFor="name">Name</label>
            <Field
              name="name"
              type="text"
              placeholder="Your name"
              className="w-full px-3 py-2 border rounded focus:outline-none focus:ring"
            />
            <ErrorMessage name="name" component="div" className="text-red-500 text-sm mt-1" />
          </div>

          {/* Email */}
          <div className="mb-4">
            <label className="block mb-1 font-medium" htmlFor="email">Email</label>
            <Field
              name="email"
              type="email"
              placeholder="you@example.com"
              className="w-full px-3 py-2 border rounded focus:outline-none focus:ring"
            />
            <ErrorMessage name="email" component="div" className="text-red-500 text-sm mt-1" />
          </div>

          {/* Phone */}
          <div className="mb-4">
            <label className="block mb-1 font-medium" htmlFor="phone">Phone</label>
            <Field
              name="phone"
              type="tel"
              placeholder="Phone number"
              className="w-full px-3 py-2 border rounded focus:outline-none focus:ring"
            />
            <ErrorMessage name="phone" component="div" className="text-red-500 text-sm mt-1" />
          </div>

          {/* Message */}
          <div className="mb-4">
            <label className="block mb-1 font-medium" htmlFor="message">Message</label>
            <Field
              name="message"
              as="textarea"
              rows="4"
              placeholder="Your message"
              className="w-full px-3 py-2 border rounded focus:outline-none focus:ring"
            />
            <ErrorMessage name="message" component="div" className="text-red-500 text-sm mt-1" />
          </div>

          <button
            type="submit"
            className="bg-success text-white px-4 py-2 rounded hover:bg-blue-700 transition"
          >
            Send
          </button>
        </Form>
      </Formik>
    </div>
  );
};

export default ContactForm;
